/* 2026-10-26 Yapay Seda: galeri penceresi (ana sayfa) ve galeri tiklama olaylari.
   Olaylar Shopify musteri olaylarina yayinlanir (seda_galeri_ac / _urun / _whatsapp);
   bir ozel piksel abone olursa Meta'ya ya da rapora tasinabilir. */
(function () {
  if (window.sedaGaleri) return;
  window.sedaGaleri = true;

  function yayinla(ad, veri) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ad, veri);
    } catch (e) {}
  }

  function kareKodu(el) {
    var k = el.closest('[data-sg-kare]');
    return k ? k.getAttribute('data-sg-kare') : '';
  }

  document.addEventListener('click', function (e) {
    var ac = e.target.closest('[data-sg-ac]');
    if (ac) {
      var pencere = document.getElementById(ac.getAttribute('data-sg-ac'));
      if (pencere && typeof pencere.showModal === 'function') {
        pencere.showModal();
        document.documentElement.classList.add('sg-kilit');
        // telefonda "geri" hareketi sayfadan cikmasin, pencereyi kapatsin
        history.pushState({ sgPencere: pencere.id }, '');
        yayinla('seda_galeri_ac', { kare: ac.getAttribute('data-sg-kod') || '' });
      }
      return;
    }
    if (e.target.closest('[data-sg-kapat]')) {
      e.target.closest('dialog').close();
      return;
    }
    // Perdeye tiklama: hedef pencerenin kendisi olur
    if (e.target.matches && e.target.matches('dialog.sg-dlg')) {
      e.target.close();
      return;
    }
    var urun = e.target.closest('.sg-urun a[href]');
    if (urun) {
      yayinla('seda_galeri_urun', { kare: kareKodu(urun), url: urun.getAttribute('href'), yer: 'ana_sayfa' });
      return;
    }
    var serit = e.target.closest('.sgs__link');
    if (serit) {
      yayinla('seda_galeri_urun', { kare: serit.getAttribute('data-sg-kare') || '', url: serit.getAttribute('href'), yer: 'kategori' });
      return;
    }
    var wa = e.target.closest('[data-sg-wa]');
    if (wa) yayinla('seda_galeri_whatsapp', { kare: wa.getAttribute('data-sg-wa') });
  });

  // close olayi kabarmaz; yakalama asamasinda dinlenir
  document.addEventListener(
    'close',
    function (e) {
      if (!(e.target.matches && e.target.matches('dialog.sg-dlg'))) return;
      // dugme/perde/Esc ile kapandiysa acilista eklenen gecmis kaydini geri al
      if (history.state && history.state.sgPencere === e.target.id) history.back();
      // close olayi gecikmeli gelir; arada baska pencere acildiysa kilidi birakma
      if (!document.querySelector('dialog.sg-dlg[open]')) document.documentElement.classList.remove('sg-kilit');
    },
    true
  );

  window.addEventListener('popstate', function () {
    var acik = document.querySelector('dialog.sg-dlg[open]');
    if (acik) acik.close();
  });
})();
